import React from "react";

export const NavItem = props =>
  <li className="sidebar-nav-item">
    {props.children}
  </li>;